/**
 * Expands CSS hex colors to #RRGGBB.
 * Handles #RGB / #RGBA shorthand (e.g. #f00 → #ff0000) and strips
 * an existing alpha pair from #RRGGBBAA so a new alpha can be applied.
 */
export function normalizeHexColor(
  colorCode: string | null | undefined,
): string | undefined {
  if (!colorCode) {
    return undefined;
  }

  const hex = colorCode.trim().replace(/^#/, '');

  if (hex.length === 3 || hex.length === 4) {
    const [r, g, b] = hex;
    return `#${r}${r}${g}${g}${b}${b}`;
  }

  if (hex.length === 6 || hex.length === 8) {
    return `#${hex.slice(0, 6)}`;
  }

  return undefined;
}

/**
 * Appends an 8-bit hex alpha pair to a color code.
 * Always normalizes shorthand hex first so `#f00` + `33` becomes
 * `#ff000033` (valid) instead of `#f0033` (invalid).
 */
export function hexWithAlpha(
  colorCode: string | null | undefined,
  alpha = '33',
): string | undefined {
  const normalized = normalizeHexColor(colorCode);
  return normalized ? `${normalized}${alpha}` : undefined;
}
